<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>edit</md-icon>
          </div>
          <h4 class="title">Update Workshop</h4>
        </md-card-header>

        <md-card-content>
          <md-field>
            <label>Title</label>
            <md-input v-model="title" type="text"></md-input>
          </md-field>
          <md-field>
            <md-datepicker v-model="date">
              <label>Select date</label>
            </md-datepicker>
          </md-field>
          <md-field>
            <label>Time</label>
            <md-input v-model="time" type="text"></md-input>
          </md-field>
          <md-field>
            <label>Address</label>
            <md-input v-model="address" type="text"></md-input>
          </md-field>
          <md-field>
            <label>Registration Fees</label>
            <md-input v-model="price" type="number"></md-input>
          </md-field>
        </md-card-content>

        <md-card-actions md-alignment="left">
          <md-button class="md-success" :disabled="isDisabled" @click="updateWorkshop()">
            Update <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
          </md-button>
          <md-button class="md-default" @click="$router.push('workshops')">
            Cancel
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import WorkshopService from "../../../services/WorkshopService";

export default {
  components: {},
  data() {
    return {
      workshopId: this.$route.query.id,
      isDisabled: false,
      title: "",
      date: "",
      time: "",
      address: "",
      price: 0,
    };
  },
  methods: {
    getWorkshopById() {
      WorkshopService.getWorkshopById(this.workshopId)
        .then((response) => {
          const w = response.data.data;
          this.title   = w.title;
          this.date    = w.date;
          this.time    = w.time;
          this.address = w.address;
          this.price   = w.price;
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },

    async updateWorkshop() {
      this.isDisabled = true;
      const data = {
        id:      this.workshopId,
        title:   this.title,
        date:    this.date,
        time:    this.time,
        address: this.address,
        price:   this.price,
        slug: this.title
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9\s-]/g, "")
          .replace(/\s+/g, "-")
          .replace(/-+/g, "-"),
      };

      await WorkshopService.updateWorkshop(data)
        .then((response) => {
          this.isDisabled = false;
          this.$toast.success(response.data.respones_msg);
          this.$router.push("workshops");
        })
        .catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
  },
  beforeMount() {
    if (!this.workshopId) {
      this.$toast.error("Workshop ID not found.");
      this.$router.push("workshops");
      return;
    }
    this.getWorkshopById();
  },
};
</script>

<style lang="scss" scoped>
.md-card .md-card-actions { border: none; }
</style>